module.exports = __webpack_public_path__ + "img/nsf-logo.4080f5c7.png";